var _circle, _circle2, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 88,
    viewBox: "0 0 91 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#6D7A7C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.0008,
    cy: 43.9999,
    r: 35.2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6165 43.7985C51.1587 42.2498 49.1464 41.2094 47.2355 40.3455C45.2456 39.4394 42.3628 38.7006 41.0959 36.745C40.0331 35.1225 41.4975 33.4039 42.9896 32.9008C45.3918 32.0988 48.3549 33.0654 50.4633 34.252C51.5142 34.8459 52.6231 34.2625 53.0235 33.2116C53.4646 32.0474 53.9058 30.8885 54.3404 29.7243C54.6064 29.0119 54.1771 28.1071 53.545 27.7568C51.6288 26.6888 49.6323 26.1119 47.5239 25.8301V22.2691C47.5239 21.3248 46.7324 20.5334 45.7829 20.5334H42.4984C41.5542 20.5334 40.7574 21.3248 40.7574 22.2691V26.2463C37.5072 27.1853 34.5454 29.2818 33.3917 32.6058C32.109 36.2854 32.8887 40.0953 35.6187 42.8767C37.0831 44.3754 39.0612 45.3644 40.9392 46.2112C43.0581 47.1673 45.6644 47.856 47.0327 49.8973C48.4971 52.0782 46.6033 54.2327 44.5568 54.8543C41.8097 55.68 38.4804 54.4434 36.1731 53.0014C35.1617 52.3732 33.9857 53.0237 33.6183 54.0417L32.3461 57.5909C32.0748 58.3416 32.5265 59.1515 33.1481 59.5571C35.325 60.9768 37.8233 61.6879 40.3834 61.9829V65.731C40.3834 66.234 40.5704 66.6252 40.847 66.907C40.8641 66.9254 40.8812 66.9412 40.8918 66.9583C40.9101 66.9717 40.9273 66.9867 40.9431 67.0031C41.2197 67.2797 41.6095 67.4667 42.1191 67.4667H45.4602C45.9191 67.4626 46.358 67.2786 46.6826 66.9542C47.0072 66.6299 47.1915 66.1911 47.196 65.7323V61.5892C50.8084 60.5501 53.6003 58.2204 55.0081 54.5922C56.4515 50.8969 55.2241 46.5891 52.6073 43.7972",
    fill: "url(#paint0_linear_276_28309)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2474 81.3334C81.9564 81.3334 88.2057 75.0841 88.2057 67.3751C88.2057 59.6661 81.9564 53.4168 74.2474 53.4168C66.5384 53.4168 60.2891 59.6661 60.2891 67.3751C60.2891 75.0841 66.5384 81.3334 74.2474 81.3334Z",
    fill: "url(#paint1_linear_276_28309)",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9554 60.5C73.3042 60.5 72.6796 60.7587 72.2192 61.2192C71.7587 61.6796 71.5 62.3042 71.5 62.9554C71.5 65.232 72.158 67.6382 72.5175 68.7873C72.7169 69.4257 73.3091 69.8304 73.9554 69.8304C74.6016 69.8304 75.1938 69.4257 75.3932 68.7873C75.7527 67.6382 76.4107 65.232 76.4107 62.9554C76.4107 62.6329 76.3472 62.3136 76.2238 62.0157C76.1004 61.7178 75.9196 61.4472 75.6916 61.2192C75.4636 60.9912 75.1929 60.8103 74.895 60.6869C74.5971 60.5635 74.2778 60.5 73.9554 60.5ZM72.2366 72.5312C72.2366 72.3055 72.2811 72.082 72.3674 71.8735C72.4538 71.665 72.5804 71.4755 72.74 71.3159C72.8996 71.1563 73.0891 71.0297 73.2976 70.9433C73.5061 70.857 73.7296 70.8125 73.9554 70.8125C74.1811 70.8125 74.4046 70.857 74.6131 70.9433C74.8216 71.0297 75.0111 71.1563 75.1707 71.3159C75.3303 71.4755 75.4569 71.665 75.5433 71.8735C75.6297 72.082 75.6741 72.3055 75.6741 72.5312C75.6741 72.9871 75.493 73.4243 75.1707 73.7466C74.8484 74.0689 74.4112 74.25 73.9554 74.25C73.4995 74.25 73.0623 74.0689 72.74 73.7466C72.4177 73.4243 72.2366 72.9871 72.2366 72.5312Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_276_28309",
    x1: 43.9434,
    y1: 20.5334,
    x2: 43.9434,
    y2: 67.4667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF3737"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_276_28309",
    x1: 74.2474,
    y1: 55.9168,
    x2: 74.2474,
    y2: 78.8334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF3737"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.e3e6312d89525805e7a367935b0af559.svg";
export { ForwardRef as ReactComponent };